import { render } from "./Diagnose.vue?vue&type=template&id=1f781030"
import script from "./Diagnose.vue?vue&type=script&lang=js"
export * from "./Diagnose.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__